import React, { useCallback, useEffect, useState, useContext } from 'react';
import { Controller, Control } from 'react-hook-form';
import Select from '../baseui/input/select';
import AppContext from '../../context/app/appContext';

type Option = {
	id: string;
	label: string;
};

interface IAsyncSelect {
	name: any;
	control: Control;
	setShowLoader: (value: boolean) => void;
	getOptions: (app: any) => Array<Option>;
	mode: string;
}

const AsyncSelect: React.FC<IAsyncSelect> = (props) => {
	const { name, control, mode, setShowLoader, getOptions } = props;
	const [options, setOptions] = useState<Array<Option>>([]);
	const { app } = useContext(AppContext);

	const getSelectOptions = useCallback(async () => {
		setShowLoader(true);

		setOptions(await getOptions({ app, mode }));
		setShowLoader(false);
	}, []);
	useEffect(() => {
		getSelectOptions();
	}, []);

	return (
		<>
			{options && options.length >= 1 && (
				<Controller
					control={control}
					name={name}
					render={({ field: { onChange, value } }) => {
						return (
							<Select {...props} options={options} value={value} onChange={onChange} labelKey='label' valueKey='id' />
						);
					}}
				/>
			)}
		</>
	);
};

export default AsyncSelect;
